<mat-form-field fxFlex [floatLabel]="'always'">
  <mat-label> {{ "Selector." + entity | translate }} </mat-label>

  <mat-select
    class="select-chip"
    [formControl]="formControl"
    multiple="true"
    [disabled]="isDisabled"
  >
    <mat-select-trigger>
      <mat-chip-list #chipList>
        <mat-chip
          *ngFor="let item of selectedEntityList"
          [selectable]
          removable
          [matTooltip]="displayLabel(item)"
          (removed)="unselectEntity(item)"
        >
          <p>{{ displayLabel(item) }}</p>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </mat-select-trigger>

    <mat-option>
      <ngx-mat-select-search
        [formControl]="filterControl"
        [placeholderLabel]="'app.actions.search' | translate"
        [noEntriesFoundLabel]="'app.actions.no-record' | translate"
        [searching]="isLoading"
        [clearSearchInput]="false"
        [disableScrollToActiveOnOptionsChanged]="true"
      >
      </ngx-mat-select-search>
    </mat-option>

    <!-- Keep selected items in the panel so the trigger stays populated -->
    <mat-option
      *ngFor="let selectedEntity of selectedEntityList"
      [disabled]="isLoading"
      [value]="selectedEntity"
    >
      {{ displayLabel(selectedEntity) }}
    </mat-option>

    <mat-divider></mat-divider>

    <mat-option
      *ngFor="let item of getListWithoutSelectedItems()"
      [disabled]="isLoading"
      [value]="item"
      [matTooltip]="displayLabel(item)"
    >
      {{ displayLabel(item) }}
    </mat-option>

    <button
      *ngIf="total > list.length"
      [disabled]="isLoading"
      (click)="onSeeMoreButton()"
      mat-button
      fxFill
    >
      <mat-icon>expand_more</mat-icon>
      <span>
        {{
          "app.actions.seeMore"
            | translate
              : {
                  n:
                    total - list.length < param.pagination.pageSize
                      ? total - list.length
                      : param.pagination.pageSize
                }
        }}
      </span>
    </button>
  </mat-select>
</mat-form-field>
